import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Backdrop, CircularProgress, Divider } from '@mui/material';
import { useMediaQuery } from 'react-responsive';
import { AppActions, CustomLink } from '../../types/decisions';
import { getEnvironmentVariable } from '../../utils';
import headerLogo from '../../assets/images/slogo.svg';
import { useAuth } from '../../context/auth-context';
import './header.scss';

const platformURL = getEnvironmentVariable('REACT_APP_PLATFORM_URL');
const LOGIN_URL = `${platformURL}/login`;
const REGISTRATION_URL = `${platformURL}/register`;

const Header: React.FC<{
    headerLinks: CustomLink[];
    externalItems: CustomLink[];
    showDecide: boolean;
    showReset: boolean;
    onActionClick?: ((action: AppActions) => void) | null;
}> = ({
    headerLinks,
    externalItems,
    showDecide,
    showReset,
    onActionClick,
}) => {
    const { isTokenLoading, isAuthenticated, userInfo } = useAuth();
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const navigate = useNavigate();
    const [ mobileNavActive, setMobileNavActive ] = useState(false);

    const toggleMobileNav = () => {
        setMobileNavActive(!mobileNavActive);
    };

    const onClick = (
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
        action: 'DECIDE' | 'IMPORTANCE' | 'SETTINGS' | 'RESET',
    ) => {
        e.stopPropagation();
        e.preventDefault();

        onActionClick?.(action);
    };

    return (
        <>
            <header className="header">
                <div className="header__logo">
                    <img src={headerLogo} alt="logo" onClick={() => navigate('/')}/>
                </div>
                <nav className={`header__nav ${mobileNavActive ? 'active' : ''}`}>
                    {isMobile && <Divider/>}
                    {showDecide && (
                        <Link
                            key="decide" to=""
                            onClick={(e) => onClick(e, 'DECIDE')}
                            className="header__link"
                        >
                            Decide
                        </Link>
                    )}
                    {showReset && (
                        <Link
                            key="reset" to=""
                            onClick={(e) => onClick(e, 'RESET')}
                            className="header__link"
                        >
                            Reset
                        </Link>
                    )}
                    {headerLinks.map(item => (
                        <Link
                            key={item.label}
                            to={item.link}
                            target="_blank"
                            className="header__link"
                        >
                            {item.label}
                        </Link>
                    ))}
                    {isMobile && externalItems.length > 0 && (
                        <>
                            <Divider/>
                            {externalItems.map(item => (
                                <Link
                                    key={item.label}
                                    to={item.link}
                                    target="_blank"
                                    className="header__link"
                                >
                                    {item.label}
                                </Link>
                            ))}
                        </>
                    )}
                    <Divider/>
                    <div className="header__buttons">
                        {isTokenLoading ? (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <CircularProgress size={15}/>
                            </div>

                        ) : (
                            <>
                                {isAuthenticated ? (
                                    <>Hello {userInfo?.name}</>
                                ) : (
                                    <>
                                        <Link
                                            className="header__button header__button--signup"
                                            to={REGISTRATION_URL}
                                        >
                                            Sign up
                                        </Link>
                                        <Link
                                            className="header__button header__button--login"
                                            to={LOGIN_URL}
                                        >
                                            Login
                                        </Link>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </nav>
                {/*<iframe*/}
                {/*    style={{ display: "none" }}*/}
                {/*    title='-'*/}
                {/*    ref={iframeRef}*/}
                {/*    src='https://platform.sparkdit.com/auth'*/}
                {/*    onLoad={onIframeLoad}*/}
                {/*/>*/}
                {/*<div className="header__menu-icon" onClick={toggleMobileNav}>☰</div>*/}
                <div className="header__menu-icon" onClick={toggleMobileNav}>
                    {mobileNavActive ? <>&times;</> : <>&#9776;</>}
                </div>
            </header>
            <Backdrop open={mobileNavActive} onClick={() => setMobileNavActive(false)}/>
        </>
    );
};

export default Header;
